import type Behavior from 'web-app/behaviors/behavior';
import {UkPackageId} from 'web-app/react/famly-store/types/types';

import type {TrackingEvent} from './types';
import {TrackingEvents} from './events';

const isUkPackageTrialEvent = (eventName: string) => {
    return onlyTrackTheseEventsForCustomersOnUKPackageTrial.some(segmentEvent => segmentEvent.name === eventName);
};

const isOnUkPackageTrial = (analyticsBehavior: Behavior) => {
    return (
        analyticsBehavior?.payload?.meta?.packages?.some(
            pkg =>
                (pkg?.packageId === UkPackageId.ProfessionalUK || pkg?.packageId === UkPackageId.ChildminderUK) &&
                pkg?.isTrial,
        ) ?? false
    );
};

const onlyTrackTheseEventsForCustomersOnUKPackageTrial: Array<TrackingEvent> = [
    TrackingEvents.SIGN_IN_OUT_CHILD_CHECKED_IN,
    TrackingEvents.MESSAGING_MESSAGE_MODULE_OPENED,
    TrackingEvents.ADD_CONTACT,
    TrackingEvents.CREATE_CHILD,
    TrackingEvents.OPEN_ACCIDENT_REPORT,
    TrackingEvents.MEDICATION_FORMS_NEW_MEDICATION_FORM_OPENED,
    TrackingEvents.ACCIDENT_INCIDENT_REPORTS_NEW_REPORT_STARTED,
    TrackingEvents.NEW_PARENTAL_PERMISSION_OPENED,
    TrackingEvents.NEW_ENQUIRY_STARTED,
    TrackingEvents.ADD_FORM_BUTTON_CLICKED,
    TrackingEvents.OPEN_ASSESSMENT,
    TrackingEvents.OPEN_OBSERVATION,
    TrackingEvents.NEW_ASSESSMENT_STARTED,
    TrackingEvents.NEW_OBSERVATION_STARTED,
    TrackingEvents.ACTIVITY_LIBRARY_ITEM_OPENED,
    TrackingEvents.ACTIVITY_PLANNER_GET_STARTED_CLICKED,
    TrackingEvents.CREATE_CURRICULUM_CLICKED,
    TrackingEvents.CREATE_PLAN_STARTED,
    TrackingEvents.VIEW_INVOICE,
    TrackingEvents.OPEN_POST_MODAL,
    TrackingEvents.CATEGORY_OPENED,
];

export {isOnUkPackageTrial, isUkPackageTrialEvent};
